import { Grid, Typography } from '@material-ui/core';
import Button from 'components/button';
import { Field, Form, Input, Textarea } from 'components/forms';
import { refundForm } from 'components/forms/decorators';
import { gt } from 'components/forms/form/validators';
import SectionBanner from 'components/section-banner';
import SectionTitle from 'components/section-title';
import Spinner from 'components/spinner';
import createOtherRefundOrderMutation from 'graphql/mutations/orders/create-other-dealer-refund-order.gql';
import systemConfigQuery from 'graphql/queries/runtime-settings.gql';
import React, { Component } from 'react';
import { compose, graphql } from 'react-apollo';

@compose(
    graphql(systemConfigQuery),
)
@refundForm(createOtherRefundOrderMutation)
export default class OtherDealerRefundCreate extends Component {
    render() {
        if (this.props.data.loading) return <Spinner />;
        return (
            <Grid container direction="column">
                <SectionBanner />
                <SectionTitle title='Otras Acciones' />
                <Form
                    fields={[
                        {key: 'estimatedAmount', validators: [gt(0)]},
                        {key: 'title'},
                        {key: 'description'},
                    ]}
                    errors={this.props.errors}
                    onSubmit={this.props.onSubmit}>
                    {({getFieldProps, renderErrors, isValid}) => (
                        <Grid container spacing={2} style={{marginTop: 20}}>
                            {this.props.data.runtimeSettings.recommendedAccions &&
                                <Grid item xs={12}>
                                    <Typography variant='h2' style={{fontWeight: 'bold'}}>Acciones recomendadas</Typography>
                                    <Typography variant='h3' style={{fontStyle: 'italic'}}> {this.props.data.runtimeSettings.recommendedAccions}</Typography>
                                    <br />
                                </Grid>
                            }
                            <Grid item xs={4}>
                                <Field label='Presupuesto estimado en pesos'>
                                    <Input type='number' {...getFieldProps('estimatedAmount')} />
                                    {renderErrors('estimatedAmount')}
                                </Field>
                            </Grid>
                            <Grid item xs={4}>
                                <Field label='Título'>
                                    <Input type='text' {...getFieldProps('title')} />
                                    {renderErrors('title')}
                                </Field>
                            </Grid>
                            <Grid item xs={12}>
                                <Field label='Descripción'>
                                    <Textarea {...getFieldProps('description')} />
                                    {renderErrors('description')}
                                </Field>
                            </Grid>
                            <Grid item xs={12}>
                                {renderErrors('__all__')}
                            </Grid>
                            <Grid item container xs={12} justify='flex-end'>
                                <Grid item xs={3}>
                                    <Form.Actions>
                                        <Button theme='yellow' disabled={!isValid() || this.props.loading} fullWidth>
                                            {this.props.loading ? 'ENVIANDO...' : 'ENVIAR'}
                                        </Button>
                                    </Form.Actions>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                </Form>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./views/refunds/other-dealer/index.js